import moment from 'moment';

export const APP_STORE_CAT_ENABLED_DATE = moment.utc('2018-06-15');
export const APP_STORE_CAT_RELEASE_DATE = moment.utc('2018-07-09');
export const OWNER_MEDIA_COST_RELEASE_DATE = '2018-11-01T00:00:00';
